import script from "./DrillHoleEdgeTypes.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrillHoleEdgeTypes.vue?vue&type=script&setup=true&lang=ts"

import "./DrillHoleEdgeTypes.vue?vue&type=style&index=0&id=aa2dc25a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa2dc25a"]])

export default __exports__